<template>
  <span class="d-flex align-items-center gap-2 mw-100">
    <img :src="`/exchanges/${bot.exchangeId.toLowerCase()}.png`" style="height: 18px" class="rounded" @error="$event.target.style.display = 'none'">
    <span class="flex-grow-1 text-truncate text-start">{{ bot.title }}</span>
    <span class="badge rounded-pill badge-subtle-primary">{{ bot.tradingAccount === 'perpetual' ? 'Futures' : 'Spot' }}</span>
  </span>
</template>

<script>
// One Bot row (exchange icon + title + Spot/Futures badge), used by the Bot
// selector on the Strategies page for the dropdown options, the selected-value
// display, and the per-card Bot info row.
export default {
  name: 'BotSelectOption',
  props: {
    bot: {
      type: Object,
      required: true
    }
  }
}
</script>
